var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaidi = function SvgSaidi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 400 400"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#saidi_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A559B",
    d: "M0 0h400v400H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "saidi_svg__b",
    width: 368,
    height: 376,
    x: 40,
    y: 34,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M40 34h368v376H40z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#saidi_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D04141",
    d: "M63.262 136.966c40.464-51.113 106.617-82.23 151.208-78.799 55.372 4.26 85.127 29.577 104.355 53.242 27.686 34.075 40.464 74.539 55.372 181.024 13.612 97.226-23.225 263.918-91.577 319.454-68.15 55.371-287.508 55.372-353.528-10.649-132-132-12.737-253.433 6.43-357.788 11.927-64.934-52.248-78.061-31.945-106.484 21.297-29.816 75.09-27.686 102.225 0 27.133 27.686 36.204 55.372 27.174 132.04-6.385 54.214-59.753 187.077-8.56 221.889 53.243 36.204 153.85 23.026 179.406-68.551 25.556-91.576-17.245-190.585-63.891-193.802-61.76-4.259-111.867-47.115-76.669-91.576"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF1F31",
    d: "M193.174 232.802c-15.885-9.344-36.205-1.42-46.854-4.259 8.519 7.808 36.798 30.055 51.113 70.279 27.93 78.48 1.319 133.148 2.028 175.742 12.779-24.847 46.811-61.346 44.825-126.759-1.48-48.735-14.908-93.706-51.112-115.003"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.457,
    cy: 145.485,
    r: 51.113,
    fill: "#F3E6E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.536,
    cy: 163.031,
    r: 25.556,
    fill: "#211111"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.191,
    cy: 90.113,
    r: 51.113,
    fill: "#F3E6E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.279,
    cy: 111.873,
    r: 25.556,
    fill: "#211111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF1F31",
    d: "M299.658 543.737c-28.067 42.1-111.454 99.385-142.689 106.484 37.624-2.839 89.447-2.466 136.3-46.853 32.371-30.668 78.799-138.43 80.928-223.618-17.037 59.632-19.167 80.929-74.539 163.987"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "saidi_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h400v400H0z"
  })))));
};
export default SvgSaidi;